/** `secure` means TLS immediately on connect, not whether TLS is supported.
 * STARTTLS uses secure=false (SMTP 587, IMAP 143); implicit TLS uses true.
 */
export function emailTransportSecure(protocol: 'imap' | 'smtp', port: number, explicit?: boolean | null, legacyUseSSL?: boolean): boolean {
  if (typeof explicit === 'boolean') return explicit;
  if (protocol === 'smtp') {
    if (port === 465) return true;
    if (port === 587 || port === 25) return false;
  } else {
    if (port === 993) return true;
    if (port === 143) return false;
  }
  return legacyUseSSL ?? (protocol === 'imap');
}

export function emailAccountSecurity(account: {
  imapPort?: number | string | null; imap_port?: number | string | null;
  smtpPort?: number | string | null; smtp_port?: number | string | null;
  imapSecure?: boolean | null; imap_secure?: boolean | null;
  smtpSecure?: boolean | null; smtp_secure?: boolean | null;
  useSSL?: boolean;
}) {
  return {
    imapSecure: emailTransportSecure('imap', Number(account.imapPort ?? account.imap_port ?? 993), account.imapSecure ?? account.imap_secure, account.useSSL),
    smtpSecure: emailTransportSecure('smtp', Number(account.smtpPort ?? account.smtp_port ?? 587), account.smtpSecure ?? account.smtp_secure, account.useSSL),
  };
}

/** A port change without a mode must not retain the old port's TLS mode. */
export function withEmailConnectionSecurity<T extends object>(command: T & { imapPort?: number; imapSecure?: boolean; smtpPort?: number; smtpSecure?: boolean }) {
  return {
    ...command,
    ...(command.imapPort === undefined ? {} : { imapSecure: emailTransportSecure('imap', command.imapPort, command.imapSecure) }),
    ...(command.smtpPort === undefined ? {} : { smtpSecure: emailTransportSecure('smtp', command.smtpPort, command.smtpSecure) }),
  };
}
